import { Component, OnInit } from '@angular/core';
import { CourseService } from 'src/app/services/course.service';
import { Course } from 'src/app/models/course';

@Component({
  selector: 'app-watching',
  templateUrl: './watching.component.html',
  styleUrls: ['./watching.component.scss']
})
export class WatchingComponent implements OnInit {
  public watching:Course[];
  public watchingLoaded:boolean=false;
  public breadcrumbLinks=[];
  public thisPage:string='Currently Watching';
  public image:string='';
  public title:string='';
  public blurb:string='';

  constructor(
    private _course: CourseService
  ) { }

  ngOnInit() {
    this._course.getCurrentlyWatching(9999).subscribe(
      res=>{
        this.watching=res;
        this.watchingLoaded=true;
      }
    );
  }

}
